<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        brand?: Snippet;
        name?: Snippet;
        topInfos?: Snippet;
        rating?: Snippet;
    }

    let { brand, name, topInfos, rating }: Props = $props();
</script>

<div class="reptile-product-header--mobile">
    {@render brand?.()}
    {@render name?.()}
    {@render topInfos?.()}
    {@render rating?.()}
</div>

<div class="reptile-product-header--desktop">
    <div class="reptile-product-header__row">
        {@render brand?.()}
        {@render rating?.()}
    </div>
    {@render name?.()}
    {@render topInfos?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@otto-ec/otto-components-utils/scss/mixins';
    @use '@shared/styles/mixins' as reptileMixins;

    .reptile-product-header {
        &__row {
            @include reptileMixins.row-space-between;
        }

        &--mobile {
            display: flex;
            flex-direction: column;
            row-gap: tokens.$oc-semantic-spacing-absolute-25;
        }

        &--desktop {
            display: none;
        }

        @include mixins.breakpoint-from-l() {
            &--mobile {
                display: none;
            }
            &--desktop {
                display: flex;
                flex-direction: column;
                row-gap: tokens.$oc-semantic-spacing-absolute-25;
            }
        }
    }
</style>
